<script>
	import BatchTable from "./BatchTable/index.svelte";
	import NewBatch from "./NewBatch/index.svelte";
	import {convertData} from "../../../services/manageExportData";
	import { saveAs } from "file-saver";
	import {setState, getState} from "../../../stores.js";


	/* addNewBatch - defines the state of Batch Data
		
		true - New Batch 

		false - Batch Table

		default state : false
	*/

	// export let addNewBatch = getState('addNewBatch') || false;
	export let addNewBatch = false;
	
	export let batchFilter = null;

	let exportDataArray = null;

	
	//updates the variable in newBatch
	let newBatchType = getState('newBatchType') || 0;

	function newBatch(){

		if(newBatchType == 0){

			addNewBatch = !addNewBatch;
			setState('addNewBatch',addNewBatch);
		}
		else if(newBatchType == 1 || newBatchType == 2){

			newBatchType = 0;
			setState('newBatchType',newBatchType);	
		}
	}


	async function exportData(){

		var res = await convertData(exportDataArray);

		var todayDate = new Date().toISOString().slice(0, 10);

		var blob = new Blob([res], { type: "application/xlsx" });
    	saveAs(blob, "batchData_" + todayDate + ".xlsx");
	}	

	
</script>

<div class="batchDataContainer">

	<div class="topContainer">
		{#if addNewBatch}

			<div class="newbatch cancelNewBatch" on:click={newBatch}>
				Cancel
			</div>

		{:else}

			<div class="newbatch" on:click={() => exportData()}>
				Export Data
			</div>

			<div class="newbatch" on:click={newBatch}>
				New Batch
			</div>
		{/if}
		
	</div>

	<div class="midContainer">
		{#if addNewBatch}
			<NewBatch bind:newBatchOpen={addNewBatch} bind:newBatchType={newBatchType} />
		{:else}
			<BatchTable batchFilter={batchFilter} bind:batchFullData={exportDataArray}/>
		{/if}
		
	</div>

	<!-- <div class="botContainer">
		
	</div> -->
	
</div>


<style>
	
	.batchDataContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.topContainer{
		width: 100%;
		height: 6%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		gap: 2%;
		margin-top: 3%;
	}

	.midContainer{
		width: 100%;
		height: 94%;
	}

	.botContainer{
		display: none;
		width: 95%;
		height: 0%;
		
	}

	.newbatch{
		width: 10%;
		height: 100%;
		border: 1px rgba(255, 255, 255, 0.5) solid;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--brand-accent);
		border-radius: 3px;
		font-size: 0.9114583333333334vw;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.newbatch:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
	}


	.cancelNewBatch:hover{
		border: 1px rgba(255, 255, 255, 0.5) solid;
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);
		color: #f44336;
	}


	.newbatchOff{
		width: 10%;
		height: 100%;
		border: 1px white solid;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		opacity: 0.2;
		border-radius: 3px;
		font-size: 0.9114583333333334vw;
	}


	.formSelect{
		width: 100%;
		height: 100%;      
		/*-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;*/
		-webkit-appearance: none;
		-moz-appearance: none;
		background-color: transparent;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none;
		color: white;
		opacity: 0.8;
	}

	.minimal {
	  background-image:
	    linear-gradient(45deg, transparent 50%, gray 50%),
	    linear-gradient(135deg, gray 50%, transparent 50%),
	    linear-gradient(to right, #ccc, #ccc);
	  background-position:
	    calc(100% - 1.3020833333333333vw) calc(1em + 0.13020833333333334vw),
	    calc(100% - 0.9765625vw) calc(1em + 0.13020833333333334vw),
	    calc(100% - 2.5em) 0.5em;
	  background-size:
	    0.3255208333333333vw 0.3255208333333333vw,
	    0.3255208333333333vw 0.3255208333333333vw,
	    0.06510416666666667vw 1.5em;
	  background-repeat: no-repeat;
	}

	.formInputOption{
		width: 100%;
		height: 33.333333%;
		background-color: transparent;
		border: 0.06510416666666667vw solid white;
		border-radius:  0.1953125vw;
		color: #333;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
	}



</style>